import React from "react"
import { URLFilePicker as JassBerryURLFilePicker } from "shared/ui/berry-jass"
import { fieldToFilePicker } from "./FilePicker"

export const URLFilePicker = (props) => {
  return <JassBerryURLFilePicker {...fieldToFilePicker(props)} />
}
